import { Dispatch, SetStateAction, createContext } from 'react';

interface MenuContextData {
  retractableBreakPoint: number;
  showMenu: boolean;
  setShowMenu: Dispatch<SetStateAction<boolean>>;
}

export const MenuContext = createContext<MenuContextData>(
  {} as MenuContextData
);
